import { Components, Theme, alpha } from '@mui/material/styles';
import { gray } from '../themePrimitives';

export const tablesCustomizations: Components<Theme> = {
  MuiTableHead: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiTableCell-head': {
          fontWeight: 600,
          fontSize: '0.75rem',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: theme.palette.text.secondary,
          backgroundColor: gray[50],
          borderBottom: `2px solid ${theme.palette.divider}`,
          paddingTop: 12,
          paddingBottom: 12,
        },
      }),
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&:last-child .MuiTableCell-body': {
          borderBottom: 'none',
        },
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: '12px 16px',
        borderBottomColor: gray[100],
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: { fontWeight: 500 },
      filled: {
        '&.MuiChip-colorSuccess': {
          backgroundColor: '#d1fae5',
          color: '#065f46',
        },
      },
    },
  },
  MuiTablePagination: {
    styleOverrides: {
      root: {
        borderTop: `1px solid ${gray[100]}`,
      },
    },
  },
};
